import React, {
  createContext,
  useContext,
  useEffect,
  useReducer,
  useRef,
} from 'react';

import { useLocation } from '@reach/router';

const FiltersContext = createContext();

const initialState = {
  voivodeship: null,
  q: '',

  position: [],
  location: [],
  job_model: null,

  remote_work: false,
  stationary_work: false,
  hybrid_work: false,
  seasonal_work: false,
};

const reducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'SET_FIELD':
      return { ...state, [payload.field]: payload.value };
    case 'SET_ARRAY_FIELD': {
      const currentValues = state?.[payload.field] ?? [];
      const exists = currentValues.some((i) => i.value === payload.value.value);

      return {
        ...state,
        [payload.field]: exists
          ? currentValues.filter((i) => i.value !== payload.value.value)
          : [...currentValues, payload.value],
      };
    }
    case 'SET_REMOTE':
      return {
        ...state,
        remote_work: true,
        stationary_work: false,
        hybrid_work: false,
        seasonal_work: false,
      };
    case 'SET_STATIONARY':
      return {
        ...state,
        remote_work: false,
        stationary_work: true,
        hybrid_work: false,
        seasonal_work: false,
      };
    case 'CLEAR_FILTERS':
      return initialState;
    default:
      return state;
  }
};

const FiltersProvider = ({ children }) => {
  const locationRef = useRef({
    offersWitnessed: false,
  });
  const location = useLocation();
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    if (locationRef.current.offersWitnessed) {
      locationRef.current.offersWitnessed = false;
      dispatch({ type: 'CLEAR_FILTERS' });
    }

    if (location.action === 'PUSH' && location.pathname === '/oferty-pracy/') {
      locationRef.current.offersWitnessed = true;
    }
  }, [location]);

  return (
    <FiltersContext.Provider value={{ state, dispatch }}>
      {children}
    </FiltersContext.Provider>
  );
};

const useFilters = () => useContext(FiltersContext);

export { useFilters };
export default FiltersProvider;
